module.exports = __webpack_public_path__ + "img/pad-fill-dropdown.b6b7385e.gif";